import * as React from 'react';
import styled from 'styled-components';

import backgroundSrc from '../../assets/images/ea-background.png';
import { LocalStorageKey } from '../enums/local-storage-key.enum';

interface StSensorDotProps {
  backgroundImage: string;
}

const StBlurredBackground = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background-size: cover;
  background-color: #000000;
  filter: blur(4px);
  background-image: url(${(props: StSensorDotProps) => props.backgroundImage});
`;

class BlurredBackground extends React.Component {
  render() {
    const updatedBackgroundSrc: string = localStorage.getItem(LocalStorageKey.Background)
      ? `${localStorage.getItem(LocalStorageKey.Background)}`
      : backgroundSrc;

    return <StBlurredBackground backgroundImage={updatedBackgroundSrc} />;
  }
}

export default BlurredBackground;



// WEBPACK FOOTER //
// ./src/app/dashboard/components/BlurredBackground.tsx